import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BlobFileInfo, FileUploadDto, ObjectPath, ProposalForm } from '../Manipulate/File';
import { AiReadFile, AiRequestData } from '../Manipulate/Ai';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AIService {      
  private apiUrl = environment.apiUrl + '/ai';
  constructor(private http: HttpClient) {}
 
//   ImproveAttachment(attachmentContent: string): Observable<string> {
//     const formData = new FormData();
//     const attachmentContentt = { attachmentContent };
//     formData.append('attachmentContent', attachmentContent);
//     return this.http.post<string>(`${this.apiUrl}/improveAttachment`, {attachmentContentt});
//   }
  ImproveAttachment( attachmentContent: string = ''): Observable<AiRequestData> {
    var requestData = new AiRequestData();          
    requestData.message = attachmentContent;        
    return this.http.post<AiRequestData>(`${this.apiUrl}/improveAttachment`, requestData);
  }
  GetCredities(){
    return this.http.get<number>(`${this.apiUrl}/getCredities`);
  }
  GetInfoDocumentsByBlobPath( folderPath : string, fileName:string): Observable<AiRequestData> {
    var requestData = new AiReadFile();
    requestData.folderPath = folderPath;
    requestData.fileName = fileName;
    return this.http.post<AiRequestData>(`${this.apiUrl}/getInfoDocumentsByBlobPath`, requestData);
  }
}
